import { render, staticRenderFns } from "./WalletGroupsForm.vue?vue&type=template&id=cb1fdeec"
import script from "./WalletGroupsForm.vue?vue&type=script&lang=js"
export * from "./WalletGroupsForm.vue?vue&type=script&lang=js"
import style0 from "./WalletGroupsForm.vue?vue&type=style&index=0&id=cb1fdeec&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports